import initialState from './initialState';

import {
  FETCH_CUSTOM_REPORTS_LIST,
  FETCH_CUSTOM_REPORTS_LIST_SUCCESS,
  FETCH_CUSTOM_REPORTS_LIST_FAILURE,
  SELECT_CUSTOM_REPORT,
  FETCH_CUSTOM_REPORTS_PARAMS,
  FETCH_CUSTOM_REPORTS_PARAMS_SUCCESS,
  FETCH_CUSTOM_REPORTS_PARAMS_FAILURE,
  RUN_CUSTOM_REPORT,
  RUN_CUSTOM_REPORT_SUCCESS,
  RUN_CUSTOM_REPORT_FAILURE,
  FETCH_CUSTOM_REPORT_SET,
  FETCH_CUSTOM_REPORT_SET_SUCCESS,
  FETCH_CUSTOM_REPORT_SET_FAILURE,
  RESET_CUSTOM_REPORT,
  UPDATE_QUERY_PARAMS,
} from './types';

export default function customReportsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SELECT_CUSTOM_REPORT:
      return {
        ...state,
        customReportToViewId: action.customReportId,
        customReportData: initialState.customReportData,
        customReportSetReports: [],
      };
    case FETCH_CUSTOM_REPORTS_LIST:
      return {
        ...state,
        customReportToViewId: initialState.customReportToViewId,
        customReportData: initialState.customReportData,
        isFetchingCustomReports: true,
      };
    case FETCH_CUSTOM_REPORTS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingCustomReports: false,
        customReports: action.customReports,
      };
    case FETCH_CUSTOM_REPORTS_LIST_FAILURE:
      return {
        ...state,
        isFetchingCustomReports: false,
      };
    case RUN_CUSTOM_REPORT:
      return {
        ...state,
        isCustomReportRunInProgress: true,
      };
    case RUN_CUSTOM_REPORT_SUCCESS:
      return {
        ...state,
        isCustomReportRunInProgress: false,
        customReportData: action.response,
      };
    case RUN_CUSTOM_REPORT_FAILURE:
      return {
        ...state,
        isCustomReportRunInProgress: false,
      };
    case FETCH_CUSTOM_REPORTS_PARAMS:
      return {
        ...state,
        isFetchingCustomReportParams: true,
      };
    case FETCH_CUSTOM_REPORTS_PARAMS_SUCCESS:
      return {
        ...state,
        customReportParams: action.params,
        isFetchingCustomReportParams: false,
      };
    case FETCH_CUSTOM_REPORTS_PARAMS_FAILURE:
      return {
        ...state,
        isFetchingCustomReportParams: false,
      };
    case FETCH_CUSTOM_REPORT_SET:
      return {
        ...state,
        customReportToViewId: action.customReportId,
        customReportData: initialState.customReportData,
        isFetchingCustomReportSet: true,
        customReportSetReports: [],
      };
    case FETCH_CUSTOM_REPORT_SET_SUCCESS:
      return {
        ...state,
        customReportSetReports: action.customReports,
        isFetchingCustomReportSet: false,
      };
    case FETCH_CUSTOM_REPORT_SET_FAILURE:
      return {
        ...state,
        isFetchingCustomReportSet: false,
      };
    case RESET_CUSTOM_REPORT:
      return {
        ...state,
        customReportData: initialState.customReportData,
      };
    case UPDATE_QUERY_PARAMS:
      return {
        ...state,
        queryParams: action.queryParams,
      };
    default:
      return state;
  }
}
